import { GetBGMgr, GetWSMgr } from "@/Utils/StateLib";
import { IsBackgroundFile } from "@coreapp/utils/IsBackgroundFile";
import { appstr } from "@coreapp/utils/appstr";
import { StripExtension } from "@coreapp/utils/StripExtension";
import { GetExtension } from "@coreapp/utils/GetExtension";

export const getCurrentAppliedBackground = () => {
  const wsMgr = GetWSMgr();
  const bgMgr = GetBGMgr();
  const docMgr = wsMgr.GetDocMgr();
  const doc = docMgr?.GetCurrentDoc();
  const iWizData = doc?.GetIWizData();
  const activeBackground = bgMgr?.GetCurBackgroundName();
  const filename = docMgr.GetFileName(true);
  if (filename === activeBackground && !IsBackgroundFile(filename)) {
    return iWizData?.GetMasterFile();
  }
  return activeBackground;
};

export const DoBackgroundSavePrompt = (onSaveFn, onCancelFn) => {
  const wsMgr = GetWSMgr();
  wsMgr.DoBackgroundSavePrompt(onSaveFn, onCancelFn);
};

export const BuildBackgroundOptions = (prefixId, masterList, clickHandler) => {
  const options = [];
  const noneOption = {
    label: appstr("No background"),
    value: "None",
    dataTestId: `${prefixId}--None`,
    clickHandler: clickHandler,
    divider: true
  };
  options.push(noneOption);

  for (let masterName of masterList) {
    let option = {};
    option.clickHandler = clickHandler;
    option.label = StripExtension(masterName);
    option.value = masterName;
    option.dataTestId = `${prefixId}--${masterName}`;
    if (GetExtension(masterName) === "oc5m") option.label += " (" + appstr("Legacy") + ")";
    options.push(option);
  }

  if (options.length === 0) {
    options.push({
      label: appstr("nosearchresults"),
      disabled: true
    });
  }

  return options;
};
